import React, { useMemo } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import HomeHeader from '../Header/HomeHeader';
import Footer from '../Footer';
import CookiesDisclaimer from '../CookiesDisclaimer';

import history from '../../core/history';

import s from './Layout.css';

function HomeLayout(props) {

  const isNotHomePage = useMemo(() => {
    return history?.location?.pathname && !['/', '/home', ''].includes(history?.location?.pathname)
  }, [history?.location?.pathname])

  return (
    <div>
      <HomeHeader
        borderLess={true}
        layoutType={props.layoutType}
        homeHeaderOnly={true}
        isNotHomePage={isNotHomePage}
      />
      <main>{props.children}</main>
      <Footer />
      <CookiesDisclaimer />
    </div>
  )
}

export default compose(withStyles(s))(HomeLayout);